import { inject } from 'aurelia-framework';
import { DialogController, DialogService } from 'aurelia-dialog';
import { QuoteService } from 'pages/quotes/service';

@inject(DialogController, DialogService, QuoteService)
export class ChildQuoteLookup {
    constructor(controller, dialogService, quoteService) {
        this.controller = controller;
        this.dialogService = dialogService;
        this.quoteService = quoteService;
    }

    activate (model) {
        this.quotes = model.quotes;
        this.item = model.item;
    }

    addNew () {
        this.controller.close();
        this.dialogService.open({ viewModel: this.quoteService.add, model: this.item });
    }

    async linkChild (quoteId) {
        await this.quoteService.linkChildQuote(this.item.parentQuoteId, this.item.structureId, quoteId);
        this.controller.ok(quoteId);
    }
}